import { styled } from '@linaria/react';

const HEIGHT = 59;

const BigTextInput = ({
  searchValue,
  handleSearch,
  handleFocus,
  handleClear,
}) => {
  return (
    <Wrapper
      value={searchValue}
      onFocus={() => handleFocus(true)}
      onBlur={() => handleFocus(false)}
      onChange={(ev) => {
        handleSearch(ev.target.value);
      }}
      onKeyDown={(ev) => {
        if (ev.key === 'Escape') {
          handleClear();
        }
      }}
    />
  );
};

const Wrapper = styled.input`
  display: block;
  flex: 1;
  border: none;
  background: transparent;
  font-size: 36px;
  height: ${HEIGHT}px;
  font-family: var(--font-family-mono);
  text-align: center;
  color: inherit;

  /* Input is too big on mobile sizes, it winds up not being centered. Allow it to shrink down. */
  min-width: 0px;

  /* Covered in JS instead */
  outline: none;
`;

export default BigTextInput;
